'use strict';

const integrations = require('integrations/product/base');
const scrollAnimate = require('../components/scrollAnimate');
var globalPidObject;

function getDataLayerValue(key) {
  if (!window.dataLayer || !Array.isArray(window.dataLayer)) return null;

  for (let i = window.dataLayer.length - 1; i >= 0; i--) {
    const item = window.dataLayer[i];
    if (item && item[key] !== undefined) {
      return item[key];
    }
  }
  return null;
}

function updateShippingMessage(data, $productContainer) {
    $productContainer.find('.js-shipping-message').text(data.product.shippingMessage);
    $productContainer.find('.js-shipping-cutoff').data('cutoff', data.product.shippingCutoff.cutoff);
    setCutoff();
};

$(document).on('onhandfastshippingMessage', function (event) {
    let container = $('.js-shipping-onHandFastShippingOnly');
    let message = container.data('onhandfastshipping');
    if (container.length < 1) {
        return;
    }
    container.html(message);
});

function setCutoff() {
    var container = $('.js-shipping-cutoff');

    if (container.length < 1) {
        return;
    }

    var cutoff = container.data('cutoff');

    if (!cutoff || cutoff === 'null') {
        container.html('');
        return;
    }

    try {
        var now = new Date();
        var deadline = new Date(cutoff);
        var remaining = deadline - now;

        if (remaining <= 0) {
            container.html('');
            return;
        }
        // 23minutes will round to 1 hour
        var hours = Math.ceil(remaining / (1000 * 60 * 60));
        var timeLeft = container.data('hours').replace('999', hours);

        if (hours > 24) {
            var days = Math.ceil(hours / 24);
            timeLeft = container.data('days').replace('999', days);
        } else if (hours === 1) {
            timeLeft = container.data('hour').replace('999', hours);
        }

        var message = container.data('message');
        message = message.replace('%%time%%', timeLeft);

        $(document).trigger('onhandfastshippingMessage');

        container.html(message);
    } catch (e) {
        container.html('');
    }
}

integrations.shippingCutoff = function () {
    setCutoff();
}
function engravingToolTipPopulator() {
    if ($('.tooltip-icon').hasClass('engraving-tooltip')) {
        var $tooltipEngravingMsgWrapper = $("<div>");
        $tooltipEngravingMsgWrapper.html($('.engraving-tooltip').data('original-title'));

        $tooltipEngravingMsgWrapper.find('span.engraving-cost').html($('#engravable_price').val());
        $tooltipEngravingMsgWrapper.find('span.engraving-character-limit').html($('#engrave_character_limit').val());

        $('.engraving-tooltip').attr('data-original-title', $tooltipEngravingMsgWrapper.html());
    }
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
integrations.methods.handlePostCartAdd = function (response) {
    // conditional added for response, sometimes it was failing when called on page load
    if (response) {
        // update event id's for next add to cart event
        if (response.eventIds) {
            window.dataLayer = window.dataLayer || [];

            for (let i = 0; i < window.dataLayer.length; i++) {
                if (window.dataLayer[i].fbAddToCartEventID != undefined) {
                    window.dataLayer.splice(i, 1);
                    break;
                }
            }
            window.dataLayer.push(response.eventIds);
        }
        $('.minicart').trigger('count:update', response);
        var messageType = response.error ? 'alert-danger' : 'alert-success';
        var isMobile = window.isMobile();

        // show add to cart toast
        if (response.newBonusDiscountLineItem
            && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
            this.chooseBonusProducts(response.newBonusDiscountLineItem);
        } else {
            if (response.error) {
                if ($('.add-to-cart-messages').length === 0) {
                    $('body').append(
                        '<div class="add-to-cart-messages"></div>'
                    );
                }

                if(!response.reservedLimitedEditionNumber) {
                    $('.add-to-cart-messages').append(
                        '<div class="alert alert-danger add-to-basket-alert text-center"'
                        + ' role="alert">'
                        + (response.errorMessage === undefined ? response.message : response.errorMessage) + '</div>'
                    );
                }
                if (response.reservedLimitedEditionNumber) {
                    $('.le-error-message').show();
                }

            } else {
                if (isMobile) {
                    // if globalPidObject have current $(this) then execute
                    if (globalPidObject) {
                        var containerAddtoCart = globalPidObject.closest('.add-to-cart-container');                    
                        containerAddtoCart.find('.js-view-bag-button').css('display', 'block');
                        containerAddtoCart.find('.add-to-cart').css('display', 'none');
                    }
                } else {
                    if ($('.search:visible').length === 0) {
                        return;
                    }

                    var url = $('.minicart').data('action-url');
                    var count = parseInt($('.minicart .minicart-quantity').text(), 10);

                    if (count !== 0 && $('.minicart .popover.show').length === 0) {
                        $('.minicart .popover').addClass('show');
                        $('.minicart .popover').spinner().start();
                        $.get(url, function (data) {
                            $('.minicart .popover').empty();
                            $('.minicart .popover').append(data);

                            $('body').trigger('cart:updateLEMessage')

                            var isPaypalEnabled = !!($('#paypal_enabled').length > 0 && document.getElementById('paypal_enabled').value === 'true');
                            var isGooglePayEnabled = !!($('#isGooglePayEnabled').length > 0 && $('#isGooglePayEnabled').val() === 'true');

                            if (isPaypalEnabled) {
                                paypalhelper.paypalMini();
                            }
                            if (isGooglePayEnabled) {
                                onGooglePayLoaded();
                            }

                            $.spinner().stop();
                        });
                    }
                }

            }
        }

        if (response.reservedLimitedEditionNumber !== null) {
            $("#select-limited-edition").val("drop-down-msg").change();
            $("#select-limited-edition option[value='"+ response.reservedLimitedEditionNumber +"']").remove();
        }

        setTimeout(function () {
            //$('.add-to-basket-alert').remove();
            $('.add-to-cart-messages').remove();
            $('.js-view-bag-button').css('display', 'none');
            $('.add-to-cart').css('display', 'block');
        }, 5000);
    }
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
integrations.methods.getOptions = function ($productContainer) {
    var options = $productContainer
        .find('.product-option')
        .map(function () {
            //var $elOption = $(this).find('.options-select');
            //var urlValue = $elOption.val();
            //var selectedValueId = $elOption.find('option[value="' + urlValue + '"]').data('value-id');
            var selectedValueId = $(this).find('.size-item.selected').data('value-id');
            var isProductTile = $(this).closest('.product-detail').hasClass('product-tile');

            if (isProductTile) {
                selectedValueId = $(this).closest('.product-detail').find('.size-item.selected').data('value-id');
            }

            if (typeof selectedValueId == "undefined" && !isProductTile) {
                selectedValueId = $(this).find('input[name=selectedValueId]').val();
            }

            if (selectedValueId == 'engravable') {
                var optionsObj = {
                    optionId: $(this).data('option-id'),
                    selectedValueId: selectedValueId
                };

                optionsObj.engrave_price = $(this).find('input[name=engravable_price]').val() || "$0.00";
                optionsObj.engrave_message = $(this).find('input[name=engravable_message]').val() || "";

                return optionsObj;
            } else {
                return {
                    optionId: $(this).data('option-id'),
                    selectedValueId: selectedValueId
                }
            }
        }).toArray();

    return JSON.stringify(options);
};

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
integrations.methods.attributeSelect = function (selectedValueUrl, $productContainer) {
    var methods = this;

    if (selectedValueUrl && selectedValueUrl !== 'null') {
        $('body').trigger('product:beforeAttributeSelect',
            { url: selectedValueUrl, container: $productContainer });

        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: function (data) {
                methods.handleVariantResponse(data, $productContainer);
                updateShippingMessage(data, $productContainer);
                if (data.product.optionsHtml != null && data.product.optionsHtml !== '') {
                    methods.updateOptions(data.product.optionsHtml, $productContainer);
                }
                if($productContainer.hasClass('js-product-detail-page')){
                    $productContainer
                        .find('.js-simple-slider-container')
                        .each(function () {
                            initializeSlider($(this));
                        });
                }
                methods.updateQuantities(data.product.quantities, $productContainer);
                $('body').trigger('product:afterAttributeSelect',
                    { data: data, container: $productContainer });
                $('body').trigger('tooltip:init');
                engravingToolTipPopulator();
                if (data.isMaster != undefined && !data.isMaster) {
                    const robotsMeta = document.querySelector('meta[name="robots"]');
                    if(!robotsMeta) {
                        var meta = document.createElement('meta');
                        meta.name = "robots";
                        meta.content = "noindex";
                        document.head.appendChild(meta);
                    }
                }
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
};

integrations.readMore = () => {
    $(document).on('click', '.short-description .read-more', function (e) {
        e.preventDefault();
        $(this).addClass('d-none').removeClass('d-inline-block');
        $('.short-description .read-less').removeClass('d-none').addClass('d-inline-block');
        $('.short-description-text').css('display', 'inline-block');
    });

    $(document).on('click', '.short-description .read-less', function (e) {
        e.preventDefault();
        $(this).addClass('d-none').removeClass('d-inline-block');

        var $shortDescriptionText = $('.short-description-text');
        $shortDescriptionText.css('display', '-webkit-box');
        if ($shortDescriptionText.length && $shortDescriptionText.prop('scrollHeight') != $shortDescriptionText.prop('clientHeight')) {
            $('.short-description .read-more').removeClass('d-none').addClass('d-inline-block');
        }
    });

    $(document).ready(function () {
        hideShowReadButtons();
    });

    $(window).resize(function () {
        hideShowReadButtons();
    });
};

function hideShowReadButtons() {
    var $shortDescriptionText = $('.short-description-text');
    var $shortDescriptionReadMore = $('.short-description .read-more');
    var $shortDescriptionReadLess = $('.short-description .read-less');

    if ($shortDescriptionText.length) {
        if ($shortDescriptionText.prop('scrollHeight') == $shortDescriptionText.prop('clientHeight')) {
            $shortDescriptionReadMore.addClass('d-none').removeClass('d-inline-block');

            // If full description is displayed and the preview version has the same scroll and client height, remove the Read Less button
            // button and keep it in the clamped state so it can clamp properly if the window is resized smaller.
            if ($shortDescriptionText.css('display') == 'inline-block') {
                $shortDescriptionText.css('display', '-webkit-box');

                if ($shortDescriptionText.prop('scrollHeight') == $shortDescriptionText.prop('clientHeight')) {
                    $shortDescriptionReadLess.addClass('d-none').removeClass('d-inline-block');
                } else {
                    $shortDescriptionText.css('display', 'inline-block');
                }
            }
        } else {
            $shortDescriptionReadMore.addClass('d-inline-block').removeClass('d-none');
            $shortDescriptionReadLess.addClass('d-none').removeClass('d-inline-block');
        }
    };
};

integrations.engravingOption = function () {
    var scope = this;

    $(document).on('click', '.product-engraving-collapsible-content button', function (e) {
        e.preventDefault();

        if (scope.methods.checkForClickableAttribute($(this)) && !toggleObject.viewOutOfStockItems) {
            return;
        }
        var $productContainer = $(this).closest('.set-item');
        if (!$productContainer.length) {
            $productContainer = $(this).closest('.product-detail').length ? $(this).closest('.product-detail') : $(this).closest('.product-wrapper');
        }

        scope.methods.attributeSelect($(this).attr('data-url'), $productContainer);
    });
};

integrations.engravingHelper = function () {
    $(document).ready(function () {
        engravingToolTipPopulator();
    });
}

/**********
     * shared across QV and PDP
     */
integrations.addToCart = function () {
    var scope = this;
    

    $(document).on('click', 'button.add-to-cart, button.add-to-cart-global', function (e) {
        e.preventDefault();
        var addToCartUrl;
        var pid;
        var pidsObj;
        var setPids;
        var quantity;
        var isMobile = window.isMobile();
        var productDetailPage = $('.js-product-detail-page').length > 0;
        var clientTime = new Date().toISOString();
        globalPidObject = $(this);

        $('body').trigger('product:beforeAddToCart', this);
        var productOptions = $(this).closest('.product-detail').find('.product-option');
        var optionError = false;
        if (isMobile && productDetailPage) {
            //Used for scrolling to the errored section on mobile
            var firstErroredOption = null;
        }

        productOptions.each(function () {
            var productOption = $(this);
            if (productOption.data('option-id') == 'engrave') {
                var engraveMessage = productOption.find('input[name=engravable_message]');
                var engraveMessageValueEmpty = engraveMessage.length > 0 && (engraveMessage.val() == null || engraveMessage.val() == '');

                if (engraveMessageValueEmpty) {
                    optionError = true;
                    $(this).closest('.product-detail').find('.invalid-feedback').css('display', 'block');
                    $(this).closest('.product-detail').find('.tile-body-quick-add.plp-size-chart.has-sizes').css('min-height', 'inherit');
                    $(this).closest('.product-detail').find('.form-control').addClass('is-invalid');

                    if (isMobile && productDetailPage) {
                        if (firstErroredOption == null) {
                            firstErroredOption = productOption;
                        }
                    }
                };
            }

            if (productOption.data('option-id') == 'ringSizeProductOption') {
                var isProductTile = $(this).closest('.product-detail').hasClass('product-tile');

                let selectedOption = $(this).closest('.product-detail').find('.size-item.selected');
                // if (!isProductTile) {
                //     selectedOption = productOption.find('option[selected]');
                // } else {
                //     selectedOption = $(this).closest('.product-detail').find('.size-item.selected');
                // }

                if (selectedOption.length === 0 || selectedOption.data('value-id').length === 0) {
                    optionError = true;
                    $(this).closest('.product-detail').find('.invalid-feedback').css('display', 'block');
                    // $(this).closest('.product-detail').find('.tile-body-quick-add.plp-size-chart.has-sizes').css('min-height', 'inherit');
                    $(this).closest('.product-detail').find('.form-control').addClass('is-invalid');

                    if (isMobile && productDetailPage) {
                        if (firstErroredOption == null) {
                            firstErroredOption = productOption;
                        }
                    }
                };
            }
        });

        var mobileSearch = $('.search-mobile-row').first();

        if (optionError == true) {
            if (isMobile && productDetailPage) {
                if (firstErroredOption) {
                    if (mobileSearch && mobileSearch.css('display') != 'none') {
                        //Get the parent section of the errored option to scroll to
                        scrollAnimate(firstErroredOption.parent(), mobileSearch.height());
                    }
                }
            }

            return;
        }

        // No dropdown selected
        // Only require a size selection for options that actually render swatches to pick from
        // (e.g. skip the "engrave" option, which has no .size-item swatches)
        var $currentProductDetail = $(this).closest('.product-detail');
        var $variationAttributes = $currentProductDetail.find('.product-option').filter(function () {
            return $(this).find('.size-item').length > 0;
        });

        if ($variationAttributes.length > 0 && $variationAttributes.find('.size-item.selected').length == 0) {
            $currentProductDetail.find(".invalid-feedback").css("display", "block");
            // $currentProductDetail.find('.tile-body-quick-add.plp-size-chart.has-sizes').css('min-height', 'inherit');
            $currentProductDetail.find(".form-control").addClass("is-invalid");

             if (mobileSearch && mobileSearch.css('display') != 'none') {
            // Scroll to the top of the complete product tile
            var $scrollTarget = $currentProductDetail.hasClass('product-tile')
            ? $currentProductDetail
            : $variationAttributes;
            scrollAnimate($scrollTarget, mobileSearch.height());
        }

            return;
        }

        // Variation Tile
        let isProductTile = $(this).closest('.product-detail').hasClass('product-tile');
        let productTileVariation = $(this).closest('.product-detail').find('.sizes-display.variation');

        if (isProductTile && productTileVariation.length > 0) {

            let selectedOption = productTileVariation.find('.size-item.selected');

            if (selectedOption.length === 0) {
                optionError = true;
                $(this).closest('.product-detail').find('.invalid-feedback').css('display','block');
                // $(this).closest('.product-detail').find('.tile-body-quick-add.plp-size-chart.has-sizes').css('min-height', 'inherit');
                $(this).closest('.product-detail').find('.form-control').addClass('is-invalid');
                // The size selector is hidden except on hover; force it visible so the error is seen
                $(this).closest('.product-detail').find('.tile-body-quick-add.plp-size-chart').addClass('show-error');

                if (isMobile && productDetailPage) {
                    if (firstErroredOption == null) {
                        firstErroredOption = productTileVariation;
                    }
                }

                return;
            };
        }


        if ($('.set-items').length && $(this).hasClass('add-to-cart-global')) {
            setPids = [];

            var $products = $(this).closest('.product-detail').find('.product-set-item-detail');
            if (!$products.length) {
                if ($(this).closest('.quick-view-dialog').length) {
                    $products = $(this).closest('.quick-view-dialog').find('.product-set-item-detail');
                } else {
                    $products = $('.product-detail');  // pagedesigner component 'Add all to cart btn' won't have .product-set-item-detail classes
                }
            }

            $products.each(function () {
                if (!$(this).hasClass('product-set-detail')) {
                    setPids.push({
                        pid: $(this).find('.product-id').text(),
                        qty: $(this).find('.quantity-select').val(),
                        options: scope.methods.getOptions($(this))
                    });
                }
            });
            pidsObj = JSON.stringify(setPids);
        }

        pid = scope.methods.getPidValue($(this));
        quantity = ($(this).hasClass('single-variant-quick-add-to-cart') || $(this).hasClass('quick-product')) ? 1 : scope.methods.getQuantitySelected($(this));

        var $productContainer = $(this).closest('.product-detail');
        if (!$productContainer.length) {
            if ($(this).hasClass('single-variant-quick-add-to-cart')) {
                addToCartUrl = $(this).data('url');
            } else {
                $productContainer = $(this).closest('.quick-view-dialog').find('.product-detail');
                var $productModalbody = $(this).closest('.modal-content');
                addToCartUrl = scope.methods.getAddToCartUrl($productModalbody);
            }
        } else {
            addToCartUrl = scope.methods.getAddToCartUrl($productContainer);
        }
        var $lashbrookContainer = $(this).closest('.addtocartbutton');
        if (!$lashbrookContainer.length) {
            $lashbrookContainer = $productContainer;
        }

        // get add to cart event ID and pass to the request
        const eventId = getDataLayerValue('fbAddToCartEventID');
        var form = {
            pid: pid,
            pidsObj: pidsObj,
            childProducts: scope.methods.getChildProducts(),
            quantity: quantity,
            options: scope.methods.getOptions($productContainer),
            clientBrowserTime: clientTime,
            fbAddToCartEventID: eventId
        };

        var lashbrookUUID = $lashbrookContainer.find('input[name="lashbrookUUID"]').val() || null;
        var lashbrookJSON = $lashbrookContainer.find('input[name="lashbrookJSON"]').val() || null;

        if (lashbrookUUID) {
            form.lashbrookUUID = lashbrookUUID;
        }

        if (lashbrookJSON) {
            form.lashbrookJSON = lashbrookJSON;
        }

        if (!$('.bundle-item').length) {
            form.options = scope.methods.getOptions($productContainer);
        }

        if ($('#select-limited-edition').length) {
            form.limitedEdition = $('#select-limited-edition').find(":selected").val();
        }

        if ($(this).hasClass('quick-add')) {
            form.isQuickAdd = true;
        }
        $(this).trigger('updateAddToCartFormData', form);
        if (addToCartUrl) {
            $('.add-to-cart-messages').remove();
            $.spinner().start();
            $.ajax({
                url: addToCartUrl,
                method: 'POST',
                data: form,
                success: function (data) {
                    scope.methods.handlePostCartAdd(data);
                    $('body').trigger('product:afterAddToCart', data);
                    $('body').trigger('product:afterAddToCartQuickview', data); //cart page quickview only
                    $('body').trigger('product:afterAddToCartLimitedEdition', data, clientTime);
                    $.spinner().stop();
                    scope.methods.miniCartReportingUrl(data.reportingURL);
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });
};

// hide pdp limited edition invalid message
$('#select-limited-edition').on('click', function() {
    $(this).removeClass('is-invalid');
    $('.invalid-feedback').hide();
    $('.pdp-le-succsess-message').hide();
    $('.le-error-message').hide();
});

// Show on PDP message and reserved datetime if the product Limited Edition is reserved
$('body').on('product:afterAddToCartLimitedEdition', (evt, data) => {
    // Get the reserved date value from the custom object
    let reservedDateStr = data?.cart?.items?.[0]?.reservedDateModel;

    // If no value exists or it equals "No Preference", exit the function
    if (!reservedDateStr || (data.reservedLimitedEditionNumber && data.reservedLimitedEditionNumber.toLowerCase() === 'no preference')) {
        return;
    }

    // Function to parse a string in "MM/dd/yyyy h:mm a" format, assuming server time is in PDT (-07:00)
    const parseServerTime = serverTimeStr => {
        const parts = serverTimeStr.match(/(\d{2})\/(\d{2})\/(\d{4}) (\d{1,2}):(\d{2}) (AM|PM)/);
        if (!parts) return new Date(serverTimeStr);
        let [ , month, day, year, hour, minute, ampm ] = parts;
        hour = parseInt(hour, 10);
        if (ampm === 'PM' && hour < 12) hour += 12;
        if (ampm === 'AM' && hour === 12) hour = 0;
        // Build ISO string with PDT offset (-07:00)
        return new Date(`${year}-${month}-${day}T${hour.toString().padStart(2, '0')}:${minute}:00-07:00`);
    };

    // Convert the custom object value into a Date object if needed
    let reservedDate = reservedDateStr instanceof Date ? reservedDateStr : parseServerTime(reservedDateStr);

    // Convert the date to the client's local time and format it
    const timeOptions = { hour: 'numeric', minute: '2-digit', hour12: true };
    const dateOptions = { month: '2-digit', day: '2-digit', year: 'numeric' };
    let clientTimeStr = reservedDate.toLocaleTimeString(undefined, timeOptions);
    let clientDateStr = reservedDate.toLocaleDateString(undefined, dateOptions);
    const messageHTML = (data?.limitedEditionNumberCountdownBannerText ? data?.limitedEditionNumberCountdownBannerText : '').replace("{0}", clientTimeStr);

    // Show the message in the specified elements
    $('.pdp-le-succsess-message').show();
    $('.pdp-le-countdown-message').show().html(messageHTML);
});

//Attributes that display in a select dropdown (default)
integrations.selectAttribute = function () {
    var scope = this;
    $(document).on('change click', 'select[class*="select-"], .options-select, .size-item', function (e) {
        e.preventDefault();

        // Visible PLP slider size-items are handled by selectSize(); avoid duplicate requests.
        if ($(this).hasClass('size-item') && $(this).closest('.sizes-display').length) {
            return;
        }

        if ($(this).hasClass('size-item')) {
            if ($(this).hasClass('disabled') || !$(this).attr('value') || $(this).attr('value') === 'null') {
                return;
            }
        }
        var $productContainer = $(this).closest('.set-item');
        if (!$productContainer.length) {
            $productContainer = $(this).closest('.product-detail').length ? $(this).closest('.product-detail') : $(this).closest('.product-wrapper');
        }

        var selectedValueUrl = $(this).hasClass('size-item') ? $(this).attr('value') : e.currentTarget.value;
        var $engraveInput = $productContainer.find('input[name=engravable_message]');
        if ($engraveInput.length && $engraveInput.val() != null) {
            selectedValueUrl = selectedValueUrl + "&engrave_message=" + encodeURIComponent($engraveInput.val());
        }

        if (selectedValueUrl && selectedValueUrl !== 'null') {
            scope.methods.attributeSelect(selectedValueUrl, $productContainer);
        }
    });
};

integrations.methods.bindQuantityStepperButtons = function ($stepper) {
    var methods = this;
    var $select = $stepper.prev('select');
    var min = parseInt($stepper.data('min'));
    var max = parseInt($stepper.data('max'));

    $stepper.find('button').off('click').click(event => {
        event.preventDefault();
        var $button = $(event.target);
        var action = $button.data('action');
        var previousValue = parseInt($stepper.find('input').val());
        var newValue = previousValue;

        if (action === 'increase' && (previousValue + 1 <= max)) {
            newValue++;
        }
        if (action === 'decrease' && (previousValue - 1 >= min)) {
            newValue--;
        }
        if (newValue !== previousValue) {
            $select.find('option[value="' + newValue + '"]').prop('selected', true).change();
            $stepper.find('input').prop('value', newValue).prop('data-qty', newValue);
            methods.updateQuantityStepperDisabledStates($stepper);
            $('body').trigger('quantityStepper:change', $stepper);
        }
    });
}

integrations.updateAttributes = function () {
    $('body').on('product:afterAttributeSelect', function (e, response) {
        response.container.find('#sizeChartModal').attr('data-product', response.data.product.id);

        //Quickview
        if ($('.modal.show .product-quickview>.bundle-items').length) {
            $('.modal.show').find(response.container).data('pid', response.data.product.id);
            $('.modal.show').find(response.container).find('.product-id').text(response.data.product.id);
        } else if ($('.set-items').length) {
            response.container.find('.product-id').text(response.data.product.id);
        } else if ($('.modal.show .product-quickview').length) {
            $('.modal.show .product-quickview').data('pid', response.data.product.id);
            $('.modal.show .full-pdp-link').attr('href', response.data.product.selectedProductUrl);
            $('.modal.show').find(response.container).find('.product-id').text(response.data.product.id);
        } else if ($('.product-quickview-card-bonus').length) {
            var $container = $('.product-quickview-card-bonus');

            $container.data('pid', response.data.product.id);
            $container.find('.product-id').text(response.data.product.id);
            //Main PDP
        } else if ($('.product-detail>.bundle-items').length) {
            response.container.data('pid', response.data.product.id);
            response.container.find('.product-id').text(response.data.product.id);
        } else if ($('.product-set-detail').eq(0)) {
            response.container.data('pid', response.data.product.id);
            response.container.find('.product-id').text(response.data.product.id);
            response.container.find('.add-to-cart').data('pid', response.data.product.id);
        } else {
            $('.product-detail .add-to-cart').data('pid', response.data.product.id);
            $('.product-id').text(response.data.product.id);
            $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
        }

        // Product detail attributes
        if ($('.collapsible-asset-content').length && response.data.collapsibleAssetContentHTML) {
            $('.js-product-details-collapsible').remove();
            $('.collapsible-asset-content').prepend(response.data.collapsibleAssetContentHTML);
        }

        //clear errors
        if ($(".attribute").find(".form-control").hasClass("is-invalid")) {
            $(".attribute").find(".invalid-feedback").css("display", "none");
            $(".attribute").find(".form-control").removeClass("is-invalid");
        }

        if (response.data.product.noReturnPolicy) {
            $('.pdp-no-return-message').removeClass('hide-message');
        } else {
            $('.pdp-no-return-message').addClass('hide-message');
        }

    });
};

function updateSizesDisplay(container) {
    const sizesDisplay = container.find('.sizes-display');
    const sizeItems = container.find('.all-sizes .size-item');
    const startIndex = container.data('startIndex') || 0;
    const selectedIndex = container.data('selectedIndex');
    const sizeCartLimit = parseInt(container.find('.sizecart-limit').attr('data-option') || 4, 10);

    sizesDisplay.empty();

    let numberOfItemsToDisplay = getVisibleSizeCount(container, sizeItems.length, sizeCartLimit);

    for (let i = 0; i < numberOfItemsToDisplay; i++) {
        let sizeIndex = (startIndex + i) % sizeItems.length;
        let sizeItem = $(sizeItems[sizeIndex]).clone();
        // Keep selection state controlled by selectedIndex, not by source markup classes.
        sizeItem.removeClass('selected');
        if (sizeIndex === selectedIndex) {
            sizeItem.addClass('selected');
        }
        sizeItem.on('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            selectSize(container, sizeIndex);
        });
        sizesDisplay.append(sizeItem);
    }
}

function getCenteredStartIndex(selectedIndex, itemsLength, visibleCount) {
    if (selectedIndex === null || typeof selectedIndex === 'undefined' || itemsLength <= visibleCount) {
        return 0;
    }

    var middleOffset = Math.floor(visibleCount / 2);
    var startIndex = selectedIndex - middleOffset;
    var maxStartIndex = itemsLength - visibleCount;

    if (startIndex < 0) {
        return 0;
    }

    if (startIndex > maxStartIndex) {
        return maxStartIndex;
    }

    return startIndex;
}

function getVisibleSizeCount(container, itemsLength, fallbackCount) {
    var maxVisibleCount = Math.min(itemsLength, fallbackCount);
    var sizesDisplay = container.find('.sizes-display');
    var firstItem = container.find('.all-sizes .size-item').first();

    if (!sizesDisplay.length || !firstItem.length) {
        return maxVisibleCount;
    }

    var viewportWidth = sizesDisplay.innerWidth();
    if (!viewportWidth) {
        return maxVisibleCount;
    }

    var measurementItem = firstItem.clone();
    measurementItem.css({
        position: 'absolute',
        visibility: 'hidden',
        display: 'block'
    });
    sizesDisplay.append(measurementItem);

    var itemWidth = measurementItem.outerWidth(true);
    measurementItem.remove();

    if (!itemWidth) {
        return maxVisibleCount;
    }

    return Math.max(1, Math.min(maxVisibleCount, Math.floor(viewportWidth / itemWidth)));
}

function updateCustomizeRingLink(container, selectedIndex) {
    var $link = container.closest('.product-detail').find('.customize-ring-link').first();

    if (!$link.length) {
        return;
    }

    var sizeItems = container.find('.all-sizes .size-item');
    var resolvedSelectedIndex = typeof selectedIndex !== 'undefined' && selectedIndex !== null
        ? selectedIndex
        : container.data('selectedIndex');

    if (resolvedSelectedIndex === null || typeof resolvedSelectedIndex === 'undefined') {
        var selectedHiddenItem = sizeItems.filter('.selected').first();
        if (selectedHiddenItem.length) {
            resolvedSelectedIndex = sizeItems.index(selectedHiddenItem);
        }
    }

    if (resolvedSelectedIndex === null || typeof resolvedSelectedIndex === 'undefined' || resolvedSelectedIndex < 0) {
        return;
    }

    var selectedItem = sizeItems.eq(resolvedSelectedIndex);
    if (!selectedItem.length) {
        return;
    }

    var selectedValue = selectedItem.attr('data-value-id');

    if (!selectedValue) {
        return;
    }

    var href = $link.attr('href');

    if (!href) {
        return;
    }

    try {
        var outerUrl = new URL(href, window.location.origin);
        var ringUrl = outerUrl.searchParams.get('ring_url');

        if (!ringUrl) {
            return;
        }

        var decodedRingUrl;

        try {
            decodedRingUrl = decodeURIComponent(ringUrl);
        } catch (e) {
            decodedRingUrl = ringUrl;
        }

        var hashIndex = decodedRingUrl.indexOf('#');
        var hash = '';
        if (hashIndex > -1) {
            hash = decodedRingUrl.slice(hashIndex);
            decodedRingUrl = decodedRingUrl.slice(0, hashIndex);
        }

        var queryIndex = decodedRingUrl.indexOf('?');
        var basePath = queryIndex > -1 ? decodedRingUrl.slice(0, queryIndex) : decodedRingUrl;
        var queryString = queryIndex > -1 ? decodedRingUrl.slice(queryIndex + 1) : '';
        var params = new URLSearchParams(queryString);

        params.set('size', selectedValue);

        var updatedRingUrl = basePath + '?' + params.toString() + hash;
        outerUrl.searchParams.set('ring_url', updatedRingUrl);
        $link.attr('href', outerUrl.toString());
    } catch (e) {
        // Ignore malformed URLs and leave the link unchanged.
    }
}

function selectSize(container, index) {
    var sizeItems = container.find('.all-sizes .size-item');
    var sizeCartLimit = parseInt(container.find('.sizecart-limit').attr('data-option') || 4, 10);
    var visibleCount = getVisibleSizeCount(container, sizeItems.length, sizeCartLimit);

    container.data('selectedIndex', index);
    container.data('startIndex', getCenteredStartIndex(index, sizeItems.length, visibleCount));
    container.closest('.tile-body-quick-add.plp-size-chart.has-sizes').css('min-height', 'revert-layer');
    container.next('.invalid-feedback').css('display', 'none');
    updateSizesDisplay(container);
    updateCustomizeRingLink(container, index);
    updateAttributeForProductTile(container);
}

function prevClick(container) {
    let startIndex = container.data('startIndex') || 0;
    let sizeItems = container.find('.all-sizes .size-item');
    startIndex = (startIndex - 1 + sizeItems.length) % sizeItems.length;
    container.data('startIndex', startIndex);
    updateSizesDisplay(container);
}

function nextClick(container) {
    let startIndex = container.data('startIndex') || 0;
    let sizeItems = container.find('.all-sizes .size-item');
    startIndex = (startIndex + 1) % sizeItems.length;
    container.data('startIndex', startIndex);
    updateSizesDisplay(container);
}

function initializeSlider(container) {
    var sizeItems = container.find('.all-sizes .size-item');
    if (!sizeItems.length) {
        return;
    }

    var selectedValueId = container.find('.sizes-display').attr('data-selected-value-id');
    var selectedIndex = null;
    var startIndex = 0;
    var sizeCartLimit = parseInt(container.find('.sizecart-limit').attr('data-option') || 4, 10);
    var visibleCount = getVisibleSizeCount(container, sizeItems.length, sizeCartLimit);

    if (selectedValueId) {
        sizeItems.each(function (index) {
            var itemValueId = String($(this).attr('data-value-id') || '').trim();
            if (itemValueId === String(selectedValueId).trim()) {
                selectedIndex = index;
            }
        });
    }

    if (selectedIndex === null) {
        sizeItems.each(function (index) {
            if ($(this).hasClass('selected')) {
                selectedIndex = index;
                return false;
            }
            return true;
        });
    }

    if (selectedIndex === null || typeof selectedIndex === 'undefined') {
        selectedIndex = null;
    }

    startIndex = getCenteredStartIndex(selectedIndex, sizeItems.length, visibleCount);

    container.data('startIndex', startIndex);
    container.data('selectedIndex', selectedIndex);
    container.removeData('sliderInitialized');

    container.find('.prevBtn').off('click').on('click', function () {
        prevClick(container);
    });
    container.find('.nextBtn').off('click').on('click', function () {
        nextClick(container);
    });

    container.data('sliderInitialized', true);
    updateSizesDisplay(container);
    updateCustomizeRingLink(container, selectedIndex);
}
window.initializeSlider = initializeSlider;

window.addEventListener('load', function () {
    $('.js-simple-slider-container').each(function () {
        initializeSlider($(this));
    });

    $('body').trigger('product:qacBorder');
});

$('body').on('search:sort--success search:showMore--success search:filter--success', function () {
    $('.js-simple-slider-container').each(function () {
        initializeSlider($(this));
    });

    $('body').trigger('product:qacBorder');
})

$('body').on('product:qacBorder', function () {
    $('.product-tile').each(function () {
        if ($(this).find('.tile-body-quick-add').length) {
            $(this).addClass('has-quick-add');
        }
    });
})

function updateAttributeForProductTile(container) {
    var $productContainer = container.closest('.product-detail');
    if (!$productContainer.length) {
        $productContainer = $(this).closest('.product-detail').length ? $(this).closest('.product-detail') : $(this).closest('.product-wrapper');
    }
    var selectedSizeItem = $productContainer.find('.size-item.selected').first();

    if (selectedSizeItem.length === 0) {
        return;
    }

    var selectedValueUrl = selectedSizeItem.attr('value');

    //  At this point we don't have engraving, but it will be added soon
    //
    // if ($productContainer.find('input[name=engravable_message]').val() != null) {
    //     selectedValueUrl = selectedValueUrl + "&engrave_message=" +
    //      encodeURIComponent($productContainer.find('input [name=engravable_message]').val());
    // }
    //

    if ($productContainer.find('.sizes-display.variation').length) {
        integrations.methods.attributeSelect(selectedValueUrl, $productContainer);
    }
}

$('body').on('modal:loaded', function () {
    $('#quickViewModal')
        .find('.js-simple-slider-container')
        .each(function () {
            initializeSlider($(this));
        });
});

module.exports = integrations;
